import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddNewNotePopupComponent } from './add-new-note-popup/add-new-note-popup.component';
import { ConfirmationType, Modules, NotificationDetails, NotificationHeader, NotificationTextMessage } from '@app/core/Enum';
import { Store } from '@ngxs/store';
import { GetAdditionalNotesAndPolicies } from '@app/core/Store';
import { Guid } from 'guid-typescript';
import { ConfirmationBoxComponent } from '@app/modules/common';

@Component({
  selector: 'app-additionals-notes',
  templateUrl: './additionals-notes.component.html',
  styleUrls: ['./additionals-notes.component.scss']
})
export class AdditionalsNotesComponent implements OnInit {

  dataSource : any = [
    {
      id : 1,
      title : "ABC",
      status : "Active"
    },
     {
      id : 2,
      title : "BCD",
      status : "InActive"
    }
  ];

  @Input() subModule:string;
  column: string[] = ['title', 'status', 'action']

  totalSelectedRecords = 0;
  moduleId = Modules.Additionalnotes;
  gridActions: any[];
  selectedItems = new Set<any>();

  isAllSelected = false;
commonNotificationText = NotificationTextMessage;


  constructor(private spinner: NgxSpinnerService, private dialog: MatDialog,private store: Store) {}

  ngOnInit(): void {

    this.getAllDislcosuresNotesByType();
  }

  addNewNote(eledata:any): void {
  let rowdata={row:eledata,type:this.subModule};
    this.dialog
      .open(AddNewNotePopupComponent, {data:rowdata,
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          this.getAllDislcosuresNotesByType();
        }
    });
  }



  onCheckBoxSelected(event: any, element: any): void {
    if (event.checked) {
      this.selectedItems.add(element);
    } else {
      this.selectedItems.delete(element);
    }
    this.totalSelectedRecords = this.selectedItems.size;
     this.isAllSelected = this.dataSource.every(
      (item: any) => item.isSelected === true
    );
    this.showFooter();
  }

  
  selectAll(event: any): void {
    this.dataSource.forEach((x) => (x.isSelected = event.checked));
    this.showFooter();
  }
  getAllDislcosuresNotesByType(): void{
    this.ids=[];
        this.spinner.show();
      this.store.dispatch(new GetAdditionalNotesAndPolicies(this.subModule?this.subModule:'Notes')).pipe().subscribe(
        (response: any) => {
          let res = response?.annualReport?.notes?.additionalDisclosure;
          this.dataSource=res;
          
        }
      );
    }

 cancelSelectionClick(): void {
    this.deSelectAll();
  }

  deSelectAll(): void {
    this.dataSource.forEach((x) => (x.isSelected = false));
    this.isAllSelected = false;
    this.totalSelectedRecords = 0;
    this.showFooter();
  }
ids:any=[];
   getSelectedIds(data?: any): void {
      this.ids = [];
  
      if (data === undefined) {
        this.dataSource.forEach((x:any) =>
          x.isSelected ? this.ids!.push(x.id!) : (Guid.EMPTY as unknown as Guid)
        );
      } else {
        this.ids.push(data.id);
      }
    }

     showFooter(): void {
    this.getSelectedIds();
    this.totalSelectedRecords = this.ids!.length;
  }

   archiveAndRestoreClick(isArchive: any): void {
       this.getSelectedIds();
            this.dialog
              .open(ConfirmationBoxComponent, {
                data: {
                  ids: this.ids,
                  isArchive,
                  typeofAction:this.subModule?this.subModule:'Notes',
                 // multipleModulesIds: this.multipleModulesIds,
                  type: ConfirmationType.Archive,
                  moduleId: this.moduleId,
                  totalNumberOfRecordSelected: this.ids.length,
                  headerText: isArchive
                    ? NotificationHeader.archiveConfirmation
                    : NotificationHeader.restoreConfirmation,
                  detailText: isArchive
                    ? NotificationDetails.archiveDetailText
                    : NotificationDetails.restoreDetailText,
                },
              })
              .afterClosed()
              .subscribe((result) => {
                if (result) {
                  this.ids = [];
               
                  this.getAllDislcosuresNotesByType();
                  this.cancelSelectionClick();
                }
              });
         
     
    }

    DeleteNote(eledata:any): void {
      if(eledata?.id){
      let ids:any=[];
        ids.push(eledata?.id);
      this.dialog
      .open(ConfirmationBoxComponent, {
        data: {
          data:{type:(this.subModule)?(this.subModule):('Notes')},
          ids: ids,
          type: ConfirmationType.Delete,
          moduleId: Modules.Additionalnotes,
          totalNumberOfRecordSelected: 1,
          headerText: NotificationHeader.deleteConfirmation,
          detailText: NotificationDetails.deleteAllDetailText,
        },
      })
      .afterClosed()
        .subscribe((result: boolean) => {
          if (result) {
             this.cancelSelectionClick();
            this.getAllDislcosuresNotesByType();
          }
      });
    }
    }

    deleteClick(): void {
     this.getSelectedIds();
    if (this.ids.length > 0) {
      this.dialog
      .open(ConfirmationBoxComponent, {
        data: {
          data:{type:(this.subModule)?(this.subModule):('Notes')},
          ids: this.ids,
          type: ConfirmationType.Delete,
          moduleId: Modules.Additionalnotes,
          totalNumberOfRecordSelected: 1,
          headerText: NotificationHeader.deleteConfirmation,
          detailText: NotificationDetails.deleteAllDetailText,
        },
      })
      .afterClosed()
        .subscribe((result: boolean) => {
          if (result) {
             this.cancelSelectionClick();
            this.getAllDislcosuresNotesByType();
          }
      });
    }
  }
}
